// extracted by mini-css-extract-plugin
export default {"container":"TodoList_container__7q4Rj","upper":"TodoList_upper__1A9a5","title":"TodoList_title__UcskR","add_btn":"TodoList_add_btn__I2Gxo","list":"TodoList_list__KWtuq"};